import {Injectable} from '@angular/core';
import {
  CrudService,
  deserialize,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
  serialize,
} from '@tisa-group/cdk';
import {UmpireTransmissionProvider} from '@tisa-group/models';
import {Observable} from 'rxjs';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';

const TRANSMISSION_PROVIDERS_PATH = '/transmission_providers';

@Injectable()
export class TransmissionProviderService
  implements CrudService<UmpireTransmissionProvider>
{
  constructor(readonly http: TisaUmpireHttpService) {}

  list(
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireTransmissionProvider[]>> {
    return this.http
      .get(TRANSMISSION_PROVIDERS_PATH, {params: objectToHttpParams(params)})
      .pipe(deserialize());
  }

  fetch(
    fetchIdentifier: string,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireTransmissionProvider>> {
    return this.http
      .get(`${TRANSMISSION_PROVIDERS_PATH}/${fetchIdentifier}`, {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  delete(id: string): Observable<void> {
    return this.http.delete(`${TRANSMISSION_PROVIDERS_PATH}/${id}`);
  }

  create(
    body: Partial<UmpireTransmissionProvider>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireTransmissionProvider>> {
    return this.http
      .post(TRANSMISSION_PROVIDERS_PATH, serialize({stuff: body}), {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  update(
    body: Partial<UmpireTransmissionProvider>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireTransmissionProvider>> {
    return this.http
      .patch<JsonApiResponse<UmpireTransmissionProvider>>(
        `${TRANSMISSION_PROVIDERS_PATH}/${body.id}`,
        serialize({stuff: body}),
        {
          params: objectToHttpParams(params),
        },
      )
      .pipe(deserialize());
  }
}
